import { instrumentQueryKeys } from '@/config/queryKeys';
import { INSTRUMENTS_QUERY_GC_TIME, INSTRUMENTS_QUERY_STALE_TIME } from '@/constants';
import { fetchInstruments } from '@/services/instruments';
import type { InstrumentPublic } from '@/types';
import { useQuery } from '@tanstack/react-query';

// POR-485: `enabled` defaults to true so existing callers are unaffected; Instruments passes its
// own auth-gate result so a denied/unresolved session never issues the request in the first place.
export function useInstruments(orgId: string, initialData?: InstrumentPublic[], enabled = true) {
  return useQuery<InstrumentPublic[]>({
    queryKey: instrumentQueryKeys.list(orgId),
    queryFn: () => fetchInstruments(orgId),
    initialData,
    staleTime: INSTRUMENTS_QUERY_STALE_TIME,
    gcTime: INSTRUMENTS_QUERY_GC_TIME,
    enabled: !!orgId && enabled,
  });
}
